module.exports = __webpack_public_path__ + "static/media/gray_ arrows.688441b5.svg";